import styles from './CircularSpinner.module.css';

export const CircularSpinner = ({
  className,
  style,
  color,
  size = 24,
  strokeWidth = 2,
}: {
  className?: string;
  style?: React.CSSProperties;
  color?: string;
  size?: number;
  strokeWidth?: number;
}) => {
  const isValidColor = (color: string | undefined) => {
    if (!color) return false;
    const hexRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
    const rgbaRegex =
      /^rgba?\(\s*(\d{1,3}\s*,\s*){2,3}\d{1,3}\s*(,\s*(0|1|0?\.\d+))?\)$/;
    return hexRegex.test(color) || rgbaRegex.test(color);
  };

  const safeColor = isValidColor(color) ? color : 'rgba(0, 0, 0, 0.3)';

  return (
    <div
      className={className ? `${styles.root} ${className}` : styles.root}
      style={{
        ...style,
        width: size,
        height: size,
        borderWidth: strokeWidth,
        borderColor: `${safeColor} transparent ${safeColor} ${safeColor}`,
        borderRadius: '50%',
      }}
    />
  );
};
